import React from 'react';
import {
  LayoutDashboard,
  ShoppingCart,
  Users,
  Share2,
  TrendingUp,
  Activity,
  ShieldCheck,
} from 'lucide-react';

const tabs = [
  { id: 'dashboard', label: 'Обзор', icon: LayoutDashboard },
  { id: 'orders', label: 'Ордера', icon: ShoppingCart },
  { id: 'users', label: 'Юзеры', icon: Users },
  { id: 'kyc', label: 'KYC', icon: ShieldCheck },
  { id: 'referrals', label: 'Рефы', icon: Share2 },
  { id: 'rates', label: 'Курсы', icon: TrendingUp },
  { id: 'events', label: 'Лог', icon: Activity },
];

export default function BottomNav({ currentScreen, onNavigate }) {
  return (
    <nav className="fixed bottom-4 left-3 right-3 bg-gray-800/80 backdrop-blur-lg border border-gray-700/50 z-40 rounded-2xl shadow-lg shadow-black/40">
      <div className="flex items-center justify-around">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const active = currentScreen === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onNavigate(tab.id)}
              className={`flex flex-col items-center py-2.5 px-1 flex-1 transition-colors ${
                active ? 'text-purple-400' : 'text-gray-500'
              }`}
            >
              <Icon size={20} strokeWidth={active ? 2.5 : 1.5} />
              <span className="text-[10px] mt-0.5 font-medium">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
